module.exports = __webpack_public_path__ + "static/img/应用中心3@2x.dee320f.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/应用中心3@2x.webp
// module id = 8nUj
// module chunks = 1